import { Button, faXmark, FontAwesomeIcon, Row, Text } from 'components'
import styles from './style/borderWrapper.module.scss'
import React from 'react'
import { head } from 'lodash';

function BorderedWrapper({ children, title, onClose = null, closeIcon = null, titlestyle = null, className=null }) 
{
    return (
        <Row className={`${styles.container} ${className}`}>
            {title && <Text className={`${styles.title} ${titlestyle}`}>{title}</Text>}
            {children}

            {onClose && <Button shape="circle" size={"small"}
                className={styles.closeButton}
                icon={closeIcon ? closeIcon : <FontAwesomeIcon icon={faXmark} size='1x' color={'red'} className="mt-1" />}
                onClick={() => onClose()} />}
        </Row>
    )
}

export default BorderedWrapper
